import {
  type ExperimentAssignmentState,
  useExperimentAssignment,
} from 'components/helpers/useExperimentAssignment';

export const AVAILABLE_SOON_SEGMENT_FLAG = 'growth-26-09-available-soon';

// Variant serves GrowthBook booleans as 'true'; the localStorage QA override
// normalizes to 'on' (see getLocalFeatureFlagOverrides).
const flagIsOn = (variant: string) => variant === 'true' || variant === 'on';

export type AvailableSoonSegment = Pick<
  ExperimentAssignmentState,
  'isExperimentAssignment' | 'trackExposure'
> & {
  /** Whether the segment control may render. False until the assignment resolves. */
  enabled: boolean;
};

/**
 * The For sale / Available soon segment's GrowthBook assignment. Reads through
 * the experiment path so experiment-backed serves can report exposure; QA
 * overrides via localStorage `opendoor.cosmos.<flag>` still win.
 */
export const useAvailableSoonSegment = (): AvailableSoonSegment => {
  const assignment = useExperimentAssignment({
    experimentKey: AVAILABLE_SOON_SEGMENT_FLAG,
    honorLocalOverride: true,
  });

  return {
    enabled: assignment.variant != null && flagIsOn(assignment.variant),
    isExperimentAssignment: assignment.isExperimentAssignment,
    trackExposure: assignment.trackExposure,
  };
};
